/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.class-rank'},
});

const ClassRankItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/class-rank"
    title={messages.title}
  />
);

export default ClassRankItem;
